module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Heavy.a89f9832.ttf";